import { useEffect } from "react";

/**
 * Set <title> and <meta name="description"> per route for SEO.
 * Falls back to defaults defined in public/index.html otherwise.
 */
export default function usePageMeta({ title, description }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", "description");
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", description);
    }
  }, [title, description]);
}
